// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2TJtk","footer":"ModalFilter_footer__3oVJ7"};